import { QueryKeysAndFnOptions } from '../hooks/useQueryKeysAndFnToCache/useQueryKeysAndFnToCache.types';

export default class OfflineDataDownloaderChunkValidator {
  private lastPriority: number = 0;

  constructor(private validateIfCanFinish: (queries: QueryKeysAndFnOptions) => Promise<void>) {}

  async validateNext(
    chunk: QueryKeysAndFnOptions,
    allQueries: QueryKeysAndFnOptions,
  ): Promise<void> {
    if (!chunk.length) {
      return;
    }

    const currentPriority = chunk[0].priority;

    if (this.isMovingToNextPriority(currentPriority)) {
      const previousGroup = this.getQueriesFromPreviousPriority(allQueries);
      previousGroup.length && (await this.validateIfCanFinish(previousGroup));
    }

    this.lastPriority = currentPriority;
  }

  private isMovingToNextPriority(currentPriority: number): boolean {
    return currentPriority > this.lastPriority;
  }

  private getQueriesFromPreviousPriority(allQueries: QueryKeysAndFnOptions): QueryKeysAndFnOptions {
    return allQueries.filter((query) => query.priority === this.lastPriority);
  }
}
